import axios from 'axios'

/**
 * 请求函数 - 统一入口
 */
const homeAxios = {
  async getMyInfoList() {
    // const result = await axios.post('/ecoSystem/home/contract-new-dashboard') //old
    const result = await axios.post('/ecoSystem/signtask-manager/count-person-signtask') // 个人签署统计 ioo
    return result.data
  },
  // 最近文件
  // async getQrecentList(data) { // old
  //   const result = await axios.post(`/ecoSystem/contract/list`, data)
  //   return result.data
  // },

  async getQrecentList(data) {
    // ioo，同合同列表接口
    const result = await axios.post(`/ecoSystem/signtask-manager/list-person-signtask`, data)
    return result.data
  },

  async checkOpenId(data) {
    const result = await axios.post(`/ecoSystem/api/v1/account/checkOpenId`, data)
    return result.data
  },

  // 签名：for企微内置浏览器下显示通讯录组件 ioo
  async getSignature(data) {
    const result = await axios.post(`/ecoSystem/api/v1/account/get-signature`, data)
    return result.data
  },

  //升级5.1: 查询v5升级弹窗展示状态
  async getDialog() {
    const result = await axios.get('/ecoSystem/api/v1/temp/upgrade/show-dialog')
    return result.data
  },
  // 升级5.1: 更新v5升级弹窗展示状态
  async updateDialog(isShow) {
    const result = await axios.get('/ecoSystem/api/v1/temp/upgrade/update-show-dialog?isShow=' + isShow, { isShow })
    return result.data
  },

  // 升级5.1: 发送短信通知管理员升级
  async sendInformAdmin() {
    const result = await axios.post('/ecoSystem/api/v1/temp/upgrade/notice-admin')
    return result.data
  },

  // 升级5.1: 企业自助升级5.1版本
  async corpUpdate() {
    const result = await axios.post('/ecoSystem/api/v1/temp/upgrade/upgrade')
    return result.data
  }
}

export default homeAxios
